//Node modules
require('jquery')

import { Application } from "stimulus"

//Custom JS
import SwiperController from './controllers/swiper-controller'
import TableController from './controllers/table-controller'
import PopupController from "./controllers/popup-controller";

import './modules/navigation/index'

const application = Application.start()

application.register("table", TableController)
application.register("swiper", SwiperController)
application.register("popup", PopupController);
